import ExcelJS from "exceljs"
import moment from "moment-timezone"
import Validations from "@/util/Validations"
import { isObject } from "@/util/utils"

export default async function ({file, config, dateFields, jsonLinesSize, headerFields}) {

    var workbook = new ExcelJS.Workbook()
    await workbook.xlsx.load(file)

    var worksheet = workbook.getWorksheet(1)

    if(!worksheet) {
        worksheet = workbook.worksheets[0] 
    }

    function parserExcelLine(line) {
        let rowJson = {}
        let rowExcel = worksheet.getRow(line)

        headerFields.forEach(headerField => {
            let fieldKey = headerField.key

            if (fieldKey == "line")
                return

            let columnNumber = config.estruturaColunas[fieldKey]
            let cell = rowExcel.getCell(columnNumber)
            let value = cell && cell.value

            if (value && dateFields.includes(fieldKey))
            {
                value = moment(value).tz('UTC').format("DD/MM/yyyy")
            }

            if (value && isObject(value) && 'richText' in value)
            {
                value = value.richText[1]?.text
            }
            
            rowJson[fieldKey] = value
        })

        return rowJson
    }

    return function parseLines (lineStart) {
        let list = []
        let lastBatch = false

        if (!worksheet) {
            return null
        }

        let start = lineStart
        let end = lineStart + jsonLinesSize

        for (let line = start; line < end; line++)
        {
            let rowJson = parserExcelLine(line)
            let nextRowJson = parserExcelLine(line+1)

            if (Validations.isEmpty(rowJson))
            {
                if(Validations.isEmpty(nextRowJson))
                {
                  lastBatch = true
                  break
                }
  
                continue;
            }
            else
            {
                rowJson.id = {line: line} //for table id in data base
                rowJson.line = line //only for presentation

                list.push(rowJson)
            }
        }

        return {list, lastBatch}
    }
}